import { createSelector } from 'reselect';
import { selectors } from 'ha/modules/AuthLogic';
import constants from 'ha/constants/commonConstants';

export default createSelector(
  [selectors.getUser],
  user =>
    !user.EmailVerified ||
    !user.Phone ||
    user.avatarURL.includes(constants.defaultAvatarUrl),
);
